import { MdOutlinePushPin } from "react-icons/md";

import { navAccent } from "../nav/navConstants";
import { NavPinnedRowActionButton, navPinnedRowLabelCss } from "./navPinnedRowStyles";
import { pinnedLinkColor } from "./pinnedLinkHelpers";

type Props = {
  uri: string;
  name: string;
  isLimitReached: boolean;
  onPin: () => void;
};

export const NavCurrentPageRow: React.FC<Props> = ({ uri, name, isLimitReached, onPin }) => {
  const accentColor = pinnedLinkColor(uri);

  const title = isLimitReached ? "Odepnij coś, by przypiąć tę stronę" : `Przypnij: ${name}`;

  return (
    <div
      title={name}
      css={{
        display: "flex",
        alignItems: "center",
        gap: "0.75rem",
        minWidth: 0,
        color: navAccent,
        "&:hover .pinned-link-pin": { opacity: isLimitReached ? 0.25 : 1 },
      }}
    >
      <span
        css={{
          flexShrink: 0,
          width: "5px",
          alignSelf: "stretch",
          minHeight: "1.5rem",
          borderRadius: "3px",
          background: accentColor,
        }}
      />

      <span css={{ ...navPinnedRowLabelCss(true), flex: 1, minWidth: 0 }}>{name}</span>

      <NavPinnedRowActionButton title={title} onClick={onPin} className="pinned-link-pin" isDisabled={isLimitReached}>
        <MdOutlinePushPin css={{ fontSize: "1rem" }} />
      </NavPinnedRowActionButton>
    </div>
  );
};
